import { render, staticRenderFns } from "./PlaylistItemAdditionalInfo.vue?vue&type=template&id=7978d8be&scoped=true"
import script from "./PlaylistItemAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./PlaylistItemAdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./PlaylistItemAdditionalInfo.vue?vue&type=style&index=0&id=7978d8be&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7978d8be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7978d8be')) {
      api.createRecord('7978d8be', component.options)
    } else {
      api.reload('7978d8be', component.options)
    }
    module.hot.accept("./PlaylistItemAdditionalInfo.vue?vue&type=template&id=7978d8be&scoped=true", function () {
      api.rerender('7978d8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PlaylistItemAdditionalInfo.vue"
export default component.exports